import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Doanhnghiepthongtin from "components/Tracuuthongtin/Doanhnghiepthongtin.js";
import Doanhnghiepphuongtien from "components/Tracuuthongtin/Doanhnghiepphuongtien.js";
import Thongbao from "components/Tracuuthongtin/Thongbao.js";
export default function DNtracuuthongtin() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Thông tin doanh nghiệp",
            tabContent: <Doanhnghiepthongtin />,
          },
          {
            tabName: "Phương tiện",
            tabContent: <Doanhnghiepphuongtien />,
          },
          {
            tabName: "Thông báo",
            tabContent: <Thongbao />,
          },
        ]}
      />
    </div>
  );
}
